import React from 'react';
import aiSunIcon from '../../../assets/icons/ai-sun-icon.png';

export function ThinkingAnimation() {
  return (
    <div className="flex items-center gap-2 py-1">
      <img src={aiSunIcon} alt="" className="w-5 h-5 ai-icon-spin" />
      <div className="flex items-center gap-1">
        <span className="w-1 h-1 rounded-full bg-[#868C98] animate-bounce" style={{ animationDelay: '0ms' }} />
        <span className="w-1 h-1 rounded-full bg-[#868C98] animate-bounce" style={{ animationDelay: '150ms' }} />
        <span className="w-1 h-1 rounded-full bg-[#868C98] animate-bounce" style={{ animationDelay: '300ms' }} />
      </div>
    </div>
  );
}
